// extracted by mini-css-extract-plugin
module.exports = {"root":"nYAv3J","icon":"w8zq54","label":"bziWap"};